export function shouldShowPublicNav({
  isDataLoaded,
  isFlowActive,
  topFlowType,
  isRentNavFlow,
  isArchiveGifts,
  showAdmin,
}) {
  if (showAdmin) return false
  if (isArchiveGifts || isRentNavFlow) return false
  return Boolean(isDataLoaded && (!isFlowActive || topFlowType === 'about'))
}
